<template>
  <v-container>
    <v-row no-gutters v-if="isShowEditor">
      <v-dialog
        v-model="snapshotDialog.isOpen"
        width="unset"
        persistent
      >
        <v-card>
          <v-card-title>Hidden snapshot</v-card-title>
          <v-card-text>
            <v-row
              ref="previewFull"
              class="mt-1"
              :style="{ position: 'relative' }"
            >
              <video
                ref="fullSizeSImage"
                crossorigin="anonymous"
                :src="snapshotDialog.videoSrc"
                :width="snapshotDialog.videoWidth"
                :height="snapshotDialog.videoHeight"
                @loadeddata="loadedFullSizeVideo"
                @seeked="seekedFullSizeVideo"
              />
              <div
                class="teaser-body"
                :style="fullSizeTeaserBodyStyle()"
              >
                <div v-if="preview.row1" class="badge-name" :style="rowOneStyle">
                  {{ preview.row1 }}
                </div>
                <div  v-if="preview.row2" class="badge-subtitle" :style="rowTwoStyle">
                  {{ preview.row2 }}
                </div>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="snapshotPreviewDialog.isOpen"
        max-width="400"
        width="unset"
        persistent
      >
        <v-card>
          <v-card-title>Snapshot preview</v-card-title>
          <v-card-text>
            <v-img
              :src="snapshotImage.image"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error"
              @click="declineResentSnapshot"
            >
              Cancel
            </v-btn>
            <v-btn
              color="success"
              @click="saveSnapshot"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col>
        <v-row>
          <v-col>
            <v-row class="flex-nowrap">
              <v-btn small @click="initFullSizeSnapshot" color="primary mt-2 mr-2">
                snap image
              </v-btn>
              <v-btn small @click="initFullSizeSnapshot(false)" color="primary mt-2 mr-2">
                save as
              </v-btn>
              <v-btn @click="prevVideo" small color="mt-2">
                prev video
              </v-btn>
              <v-btn @click="nextVideo" small color="mt-2">
                next video
              </v-btn>
              <v-btn @click="resetBadge" small color="primary mt-2">
                reset
              </v-btn>
            </v-row>
          </v-col>
          <a v-show="false" ref="download" />
        </v-row>
        <v-row class="mt-4">
          Double click on draggables to switch their order
        </v-row>
        <v-row class="mt-1">
          <v-col cols="12">
            <v-row
              ref="preview"
              class="mt-1 contains-resizable-draggable-frame"
              :style="{ position: 'relative' }"
              @dblclick="toggleFramesZIndex"
            >
              <video
                ref="thumbnail"
                crossorigin="anonymous"
                :src="geotag.videodata[video_index].uri"
                @loadeddata="videoLoaded"
                controls />
              <ResizableContainer
                ref="badge"
                v-if="isFrameShow"
                data-html2canvas-ignore="true"
                :x-pos="preview.badgeLeft"
                :y-pos="preview.badgeTop"
                :width="preview.badgeWidth"
                :height="preview.badgeHeight"
                @update="getBadgePosition"
                :z-index="badge.z"
              >
                <div
                  class="teaser-body teaser-body-frame"
                  :style="teaserBodyStyle"
                >
                  <div v-if="preview.row1" class="badge-name" :style="rowOneStyle">
                    {{ preview.row1 }}
                  </div>
                  <div  v-if="preview.row2" class="badge-subtitle" :style="rowTwoStyle">
                    {{ preview.row2 }}
                  </div>
                </div>
              </ResizableContainer>
              <ResizableFrame
                ref="frame"
                v-if="isFrameShow"
                data-html2canvas-ignore="true"
                @update="getFramePosition"
                :parent-height="$refs.thumbnail.clientHeight"
                :parent-width="$refs.thumbnail.clientWidth"
                :x-pos="preview.frameLeft"
                :y-pos="preview.frameTop"
                :width="preview.frameWidth"
                :position="preview.framePosition"
                :z-index="frame.z"
              />
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-slider
            color="orange darken-3"
            min="5"
            max="30"
            label="font size"
            v-model="preview.fontSize"
          /> {{ preview.fontSize }}px
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas';
import ResizableFrame from '../../components/ResizableFrame.vue';
import ResizableContainer from '../../components/ResizableContainer.vue';

export default {
  name: 'GeotagBanner',

  components: {
    ResizableFrame,
    ResizableContainer,
  },
  props: {
    preview: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      video_index: 0,
      geotag: {},
      isFrameShow: false,
      snapshotImage: {
        image: null,
        width: NaN,
        height: NaN,
      },
      snapshotDialog: {
        isOpen: false,
        videoSrc: null,
        videoWidth: 1080,
        videoHeight: 1920,
        heightRatio: 1,
        frameTime: 0,
        isFullSizeVideoSeeked: false,
        isFullSizeVideoLoaded: false,
        isSaveAndNotDownload: true,
      },
      snapshotPreviewDialog: {
        isOpen: false,
      },
      frame: {
        z: 2,
      },
      badge: {
        z: 1,
      },
    };
  },

  created() {
    this.$watch(
      () => this.$route.params.geotagId,
      () => {
        this.fetchGeotag();
      },
    );

    this
      .fetchGeotag(this.$route.params.geotagId);
  },

  methods: {
    initFramePositions() {
      this.$refs.frame.calculateInitPosition();
      this.$refs.badge.calculateInitPosition();
    },

    fetchGeotag() {
      return this.$requestHelpers
        .get(`api/admin/geotag/getHighQualityVideoLinks/${this.$route.params.geotagId}`)
        .then(({ data }) => {
          this.geotag = data;
          this.$emit('updated', this.geotag);
        });
    },

    prevVideo() {
      this.video_index = this.geotag.videodata[this.video_index - 1]
        ? this.video_index - 1
        : this.geotag.videodata.length - 1;
    },

    nextVideo() {
      this.video_index = this.geotag.videodata[this.video_index + 1]
        ? this.video_index + 1
        : 0;
    },

    resetBadge() {
      this.$emit('resetBadge');
      this.$nextTick(() => this.initFramePositions());
    },

    videoLoaded() {
      setTimeout(
        () => {
          this.isFrameShow = true;
          this.snapshotDialog.aspectRatio = this
            .$refs.thumbnail.videoWidth / this.$refs.thumbnail.clientHeight;
        },
        100,
      );
    },

    takeScreenshot(
      el,
      isSaveAndNotDownload,
      x = 0,
      y = 0,
      width = null,
      height = null,
      scale = 4,
    ) {
      const options = {
        scale,
        x,
        y,
        backgroundColor: null,
        allowTaint: true,
        useCORS: true,
      };

      if (width !== null) {
        options.width = width;
      }

      if (height !== null) {
        options.height = height;
      }

      html2canvas(el, options).then((canvas) => {
        this.snapshotImage.image = canvas.toDataURL('image/png');
        if (isSaveAndNotDownload) {
          this.openSnapshotPreviewDialog();
        } else {
          this.snapshotImage.image = this.snapshotImage.image.replace('image/png', 'image/octet-stream');
          this.$refs.download.setAttribute('download', `${this.geotag.name.replace(' ', '_')}.png`);
          this.$refs.download.setAttribute('href', this.snapshotImage.image);
          this.$refs.download.click();
        }
      });
    },

    initFullSizeSnapshot(isSaveAndNotDownload = true) {
      this.snapshotDialog.isFullSizeVideoLoaded = false;
      this.snapshotDialog.isOpen = true;
      this.snapshotDialog.videoSrc = this.geotag.videodata[this.video_index].uri;
      this.snapshotDialog.videoWidth = this.$refs.thumbnail.videoWidth;
      this.snapshotDialog.videoHeight = this.$refs.thumbnail.videoHeight;
      this.snapshotDialog.frameTime = this.$refs.thumbnail.currentTime;
      this.snapshotDialog.isSaveAndNotDownload = isSaveAndNotDownload;

      this.snapshotDialog.aspectRatio = this
        .$refs.thumbnail.videoHeight / this.$refs.thumbnail.clientHeight;

      this.snapshotImage.width = Math
        .floor(this.preview.frameWidth * this.snapshotDialog.aspectRatio);
      this.snapshotImage.height = Math
        .floor(this.preview.frameHeight * this.snapshotDialog.aspectRatio);
    },

    loadedFullSizeVideo() {
      this.snapshotDialog.isFullSizeVideoLoaded = true;
      this.snapshotDialog.isFullSizeVideoSeeked = false;

      this.$refs.fullSizeSImage.currentTime = this.$refs.thumbnail.currentTime;
    },

    seekedFullSizeVideo() {
      this.takeScreenshot(
        this.$refs.previewFull,
        this.snapshotDialog.isSaveAndNotDownload,
        this.preview.frameLeft * this.snapshotDialog.aspectRatio + 1,
        this.preview.frameTop * this.snapshotDialog.aspectRatio,
        this.snapshotImage.width,
        this.snapshotImage.height,
        1,
      );
      this.snapshotDialog.isOpen = false;
      this.snapshotDialog.videoSrc = null;
      this.snapshotDialog.isFullSizeVideoSeeked = false;
      this.snapshotDialog.isFullSizeVideoLoaded = false;
    },

    getFramePosition(framePosition) {
      this.$emit('update:preview',
        {
          ...this.preview,
          frameLeft: framePosition.x,
          frameTop: framePosition.y,
          frameWidth: framePosition.w,
          frameHeight: framePosition.h,
          framePosition: 'center',
        });
    },

    getBadgePosition(badgePosition) {
      this.$emit('update:preview',
        {
          ...this.preview,
          badgeLeft: badgePosition.x,
          badgeTop: badgePosition.y,
          badgeHeight: badgePosition.h,
          badgeWidth: badgePosition.w,
        });
    },

    openSnapshotPreviewDialog() {
      this.snapshotPreviewDialog.isOpen = true;
    },

    closeSnapshotPreviewDialog() {
      this.snapshotPreviewDialog.isOpen = false;
    },

    declineResentSnapshot() {
      this.closeSnapshotPreviewDialog();
      this.snapshotImage.image = null;
      this.snapshotImage.width = NaN;
      this.snapshotImage.height = NaN;
    },

    saveSnapshot() {
      if (this.snapshotImage.image === null) {
        return false;
      }

      const data = {
        image: this.snapshotImage.image,
        geotag_id: this.geotag.id,
        params: {
          width: this.snapshotImage.width,
          height: this.snapshotImage.height,
          origin_width: this.$refs.thumbnail.videoWidth,
          origin_height: this.$refs.thumbnail.videoHeight,
        },
      };

      this.$requestHelpers
        .post(
          'api/admin/deeplink',
          data,
        ).finally(() => {
          this.closeSnapshotPreviewDialog();
        });
      return true;
    },

    toggleFramesZIndex() {
      [this.frame.z, this.badge.z] = [this.badge.z, this.frame.z];
    },

    fullSizeTeaserBodyStyle() {
      return ({
        color: 'rgba(0, 0, 0, 0.87)',
        background: this.preview.color,
        left: `${this.snapshotDialog.aspectRatio * this.preview.badgeLeft}px`,
        top: `${this.snapshotDialog.aspectRatio * this.preview.badgeTop}px`,
        width: `${this.snapshotDialog.aspectRatio * this.preview.badgeWidth}px`,
        height: `${this.snapshotDialog.aspectRatio * this.preview.badgeHeight}px`,
        fontSize: `${this.snapshotDialog.aspectRatio * this.preview.fontSize}px`,
        // eslint-disable-next-line max-len
        borderRadius: `${this.snapshotDialog.aspectRatio * this.preview.fontSize * 0.5}px ${this.snapshotDialog.aspectRatio * this.preview.fontSize * 3}px`,
      });
    },
  },

  computed: {
    isShowEditor() {
      return this.geotag.videodata && this.geotag.videodata.length;
    },

    teaserBodyStyle() {
      return ({
        background: this.preview.color,
        fontSize: `${this.preview.fontSize}px`,
        borderRadius: `${this.preview.fontSize * 0.5}px ${this.preview.fontSize * 3}px`,
      });
    },

    rowOneStyle() {
      return ({
        color: this.preview.textColorRow1,
      });
    },

    rowTwoStyle() {
      return ({
        color: this.preview.textColorRow2,
      });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap');
video {
  max-width: 100%;
}
.teaser-body {
  position: absolute;
  text-align: center;
  font-family: Rubik, sans-serif;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  line-height: 1em;
  letter-spacing: 0;
}

.teaser-body-frame {
  width: 100%;
  height: 100%;
}

.badge-name {
  font-size: 2em;
  line-height: 1em;
  font-weight: 700;
}
.badge-subtitle {
  margin-top: 0.5em;
  font-size: 1em;
  font-weight: 400;
}
/deep/ .v-slider--vertical, .v-input__slider--vertical {
  height: 100%;
}
</style>
